
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useStripe } from '@/modules/stripe/model/edit';
import { ROUTE_NAME_STRIPE } from '@/modules/stripe/router';

export default defineComponent({
    name: ROUTE_NAME_STRIPE,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, fetch, actions } = useStripe();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions };
    }
});
